import { useWhitelabelContext } from "../contexts/whitelabelContext";

export const useShowSupportRequests = () => {
  const { appConfig } = useWhitelabelContext();

  return appConfig?.SHOW_SUPPORT_REQUESTS !== false;
};
